const url = '/airlines';
const Provider = 'Airlines';
const dbModel = 'Airlines';

export { url, Provider, dbModel };
